module.exports = __webpack_public_path__ + "static/img/fbbm.19a6cf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/fbbm.jpg
// module id = 0Wms
// module chunks = 0